<script setup lang="ts">
import type { IAiChatExchangeRateProvider } from './types'
import { localizedField, toCurrencyCode, organizationTypeLabel } from '../utils'
import { CurrencyIcon } from '~/components/ui/currency-icon'

const props = defineProps<{ item: IAiChatExchangeRateProvider }>()
const { t, locale } = useI18n()

const name = computed(() => localizedField(props.item.organization, locale.value))
const currencyCode = computed(() => toCurrencyCode(props.item.currency))
const typeLabel = computed(() => organizationTypeLabel(props.item.organization_type, t))
</script>

<template>
  <NuxtLink :to="item.rates_url || item.url" class="AiCard group">
    <div class="flex items-center gap-2">
      <CurrencyIcon :code="currencyCode" size="sm" />
      <div class="min-w-0 flex-1">
        <div class="truncate text-sm font-semibold text-gray-900 group-hover:text-blue-600">
          {{ name }}
        </div>
        <div class="text-xs text-gray-500">{{ typeLabel }}</div>
      </div>
      <div class="shrink-0 text-xs font-semibold uppercase text-gray-500">
        {{ item.currency }}
      </div>
    </div>
    <div class="mt-2 flex gap-4 text-sm">
      <div class="flex flex-col">
        <span class="text-xs text-gray-500">{{ $t('common.buy') }}</span>
        <span class="font-semibold text-green-600">{{ item.buy }}</span>
      </div>
      <div class="flex flex-col">
        <span class="text-xs text-gray-500">{{ $t('common.sell') }}</span>
        <span class="font-semibold text-red-500">{{ item.sell }}</span>
      </div>
    </div>
  </NuxtLink>
</template>
